import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:type",
        element: <CategoryPage />,
      },
      {
        path: "detail/:id",
        element: <DetailPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;